import moment from 'moment'

export const country = {
  id: '',
  name: '',
  updatedAt : moment().format('YYYY-MM-DD'),
}